<template>
  <strong>{{limit | formatMoney}}</strong>
</template>

<script>
export default {
  props: {
    limit: Number
  }
}
</script>



// WEBPACK FOOTER //
// ShoppingCartLimit.vue?4c2135ef